import styled from 'styled-components';

export const ToolTipContentWrapper = styled.div`
  padding: 20px;
  text-align: left;
`;
